import { useEffect } from "react";

import { useThemeSwitchingContext } from "src/contexts/ThemeSwitchingContext";
import { useIsWorkspaceLoading } from "src/contexts/global/WorkspaceContext";
import { useEnableDarkThemeSwitcherFlag } from "./useEnableDarkThemeSwitcherFlag";

/**
 * When the workspace disables the dark theme switcher, users must not remain on
 * dark mode (the toggle is hidden). Reset to light once workspace flags are known.
 */
export const useEnforceLightThemeWhenDarkSwitcherDisabled = () => {
  const enableDarkThemeSwitcher = useEnableDarkThemeSwitcherFlag();
  const isWorkspaceLoading = useIsWorkspaceLoading();
  const { isDarkTheme, themeSwitcher } = useThemeSwitchingContext();

  useEffect(() => {
    if (isWorkspaceLoading) {
      return;
    }
    if (!enableDarkThemeSwitcher && isDarkTheme) {
      themeSwitcher(false);
    }
  }, [enableDarkThemeSwitcher, isDarkTheme, isWorkspaceLoading, themeSwitcher]);
};
